export default __webpack_public_path__ + "static/media/img--design-6.776976ff.jpg";